import React from 'react';

export default function EliminatorConflictNotes({
	notes,
	className = 'mt-4 max-w-lg space-y-1 text-xs text-gray-600 dark:text-gray-400'
}) {
	if (!notes?.length) return null;

	return (
		<ul className={className}>
			{notes.map((note) => (
				<li key={note.key} className="flex items-start gap-2">
					<span
						className={`mt-0.5 flex-shrink-0 font-bold leading-none ${
							note.ok ? 'text-green-500' : 'text-red-500'
						}`}
						aria-hidden="true"
					>
						{note.ok ? '✓' : '✕'}
					</span>
					<span>{note.text}</span>
				</li>
			))}
		</ul>
	);
}
